import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SignUpUserHeader from "../../components/header/SignUpUserHeader";
import { postRequest } from "../../api";
import './UserOnboardingPage.css';
import { Col, Row, Spin } from 'antd';

const TellUsMore = ({ onboardingData, setOnboardingData, onOnboardingComplete }) => {
  const navigate = useNavigate();
  const [hobbies, setHobbies] = useState(onboardingData.hobbies || []);
  const [inputValue, setInputValue] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setHobbies(onboardingData.hobbies || []);
  }, [onboardingData.hobbies]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const setUserInfo = (response) => {
    localStorage.setItem("age", response.user.age);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      setHobbies([...hobbies, inputValue.trim()]);
      setInputValue('');
    }
  };

  const handleNext = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    sessionStorage.setItem('onboarding_in_progress', 'true');

    let personal = JSON.parse(localStorage.getItem('personalInfo'));
    let contact = JSON.parse(localStorage.getItem('contactInfo'));

    const updatedOnboardingData = {
      ...onboardingData,
      personalInfo: personal,
      contactInfo: contact,
      hobbies: hobbies,
      token: localStorage.getItem('auth_token'),
    };
    setOnboardingData(updatedOnboardingData);
    let trustedUserEmail = updatedOnboardingData.contactInfo.truetedEmail;
    let mainUserName = updatedOnboardingData.personalInfo.name;
    try {
      let trustedUser;
      if (trustedUserEmail) {
        trustedUser = await postRequest("admin/create-trusted-user", { email: trustedUserEmail, userName: mainUserName });
      }

      const response = await postRequest("/user/user-onboarding", updatedOnboardingData);

      if (response.status === 200) {
        setUserInfo(response);
        localStorage.setItem('onboardingComplete', 'true');
        if (onOnboardingComplete) {
          onOnboardingComplete();
        }
        sessionStorage.removeItem('onboarding_in_progress');
        navigate('/landing-page', { replace: true });
      }
    } catch (error) {
      console.error('Error updating user', error);
      sessionStorage.removeItem('onboarding_in_progress');
      setIsSubmitting(false);
    }
  };

  const handleBack = () => {
    navigate('/onboarding/get-to-know-you');
  };

  if (isSubmitting) {
    return (
      <div style={{
        minHeight: "100dvh",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: "#fefcfe"
      }}>
        <div style={{ textAlign: 'center' }}>
          <Spin size="large" />
          <p style={{ marginTop: '1rem' }}>Completing your profile...</p>
        </div>
      </div>
    );
  }

  return (
     <Row className="welcome-onboarding-row" style={{ background: "#fefcfe" }}>
      <Col lg={24}>
        <SignUpUserHeader />
      </Col>
      <Row gutter={24} className="welcome-onboarding-row-card-container">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          className="welcome-onboarding-inner-content-col"
        >
          <div className="onboarding-step">
            <h1>Tell us more</h1>
            <p>
              Tell us more about you, your hobbies and interests by adding the options below.
            </p>
            <div className="hobbies-tags">
              {hobbies.map((hobby, index) => (
                <span key={index} className="hobby-tag">
                  {hobby}
                </span>
              ))}
            </div>
            <input
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyPress}
              placeholder="Enter your hobby and press Enter"
            />
            <div className="button-container">
              <button
                type="button"
                onClick={handleBack}
                className="back-button"
              >
                Back
              </button>
              <button
                type="submit"
                onClick={handleNext}
                className="next-button"
              >
                Finish
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </Row>
  );
};

export default TellUsMore;